export default "__VITE_ASSET__DuSiyzvT__"